import hero from "../../Images/OuttaWax/outta-hero.jpg";

const outtaWaxData = {
  heroImage: hero,
  title: "Outta Wax",
  projectType: "Web Design // Vinyl Pressing Services",
  subtitle: [
    <>
      <a href="https://outtawax.com" target="_blank" rel="noopener noreferrer">
        outtawax.com
      </a>
    </>,
  ],
  overview:
    "I had the opportunity to help design the website for Outta Wax, a new place in Minneapolis offering vinyl pressing services. Check out the site by clicking the link above.",

  tabs: [],
};

export default outtaWaxData;
